export const formatPhoneNumber = (number) => {
  // Formats a given phone number to: (###) ###-####
  const cleanedNumber = number.replace(/\D/g, '')
  const phoneNumber = cleanedNumber.length > 10 ? cleanedNumber.slice(-10) : cleanedNumber
  const formatted = phoneNumber.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3')
  return formatted
}
